<template>
  <div
    id="main"
    :class="$mq"
  >
    <PaymentAlert v-if="paymentStatus === 'in_dunning'" />
    <CoachAlert v-if="user.role_type === 'coach'" />
    <LeaderAlert v-if="user.role_type === 'leader'" />
    <ExtendSessionAlert
      v-if="user.role_type === 'leader' && extendRequired"
      :extend-dialog.sync="extendDialog"
    />
    <ExtendDialog
      v-if="user.role_type === 'leader'"
      :extension-notice="extension_notice"
      :mode="extendMode"
      :show.sync="extendDialog"
    />

    <transition
      name="el-fade-in"
      mode="out-in"
    >
      <router-view />
    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import CoachAlert from './customAlerts/CoachAlert.vue';
import LeaderAlert from './customAlerts/LeaderAlert.vue';
import PaymentAlert from './customAlerts/PaymentAlert.vue';
import ExtendSessionAlert from './customAlerts/ExtendSessionAlert.vue';
import ExtendDialog from './customAlerts/component/ExtendDialog.vue';

export default {
  components: {
    CoachAlert,
    LeaderAlert,
    PaymentAlert,
    ExtendSessionAlert,
    ExtendDialog,
  },

  data: () => ({
    watcherStack: 0,
    extendDialog: false,
  }),

  computed: {
    ...mapState({
      user: (state) => state.user.user,
      paymentStatus: (state) => state.user.payment_status,
      extension_notice: (state) => state.processStatus.process.extension_notice,
    }),

    ...mapGetters('processStatus', {
      extendRequired: 'extendRequired',
    }),

    extendMode() {
      // extend, start
      let mode = 'extend';
      if (this.extension_notice.curr_duration && this.extension_notice.curr_duration === 13) {
        mode = 'start';
      }
      return mode;
    },
  },

  watch: {
    extension_notice: {
      deep: true,
      handler() {
        // First change is init. second change is the actual result.
        this.watcherStack += 1;
        if (this.watcherStack > 1) {
          this.openExtendDirectly();
        }
      },
    },
  },

  methods: {
    openExtendDirectly() {
      if (this.$route.query && this.$route.query['show-extend'] === 'true') {
        if (this.extension_notice && Object.entries(this.extension_notice).length > 0) {
          this.extendDialog = true;
        } else {
          this.$message.success(this.$t('customAlert.extension.alreadyRequested'));
        }
      }
    },
  },
};
</script>

<style lang="scss">
#main {
  padding: 10px 5% 60px 5%;

  .mainCard {
    max-width: 984px;
    margin: 0 auto;
  }

  &.mobile,
  &.tablet {
    // Without support button
    // padding-bottom: 75px;

    // With support button
    padding-bottom: 120px;
  }
}
</style>
